import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import { JURISDICTION_AREA, MISCELLANEOUS, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';
import JurisdictionAreaCreate from './containers/JurisdictionAreaCreate';
import JurisdictionAreaEdit from './containers/JurisdictionAreaEdit';
import JurisdictionAreaList from './containers/JurisdictionAreaList';
import JurisdictionAreaView from './containers/JurisdictionAreaView';

interface Props {}

const JurisdictionArea: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}`}>
        <JurisdictionAreaList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}/create`}>
        <JurisdictionAreaCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}/edit`}>
        <JurisdictionAreaEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${JURISDICTION_AREA}/view`}>
        <JurisdictionAreaView />
      </Route>
    </Fragment>
  );
};

export default JurisdictionArea;
